import { crmPalettes, crmTypography } from '../crm/crmPalette';
import { theme } from '../design-system/theme';

/** Design defaults for new CRM interfaces; existing CSS variables remain authoritative. */
export const crmTokens = {
  colors: crmPalettes,
  fontFamily: crmTypography,
  fontSize: theme.typography.fontSize,
  fontWeight: theme.typography.fontWeight,
  spacing: theme.spacing,
  borderRadius: theme.borderRadius,
  shadows: theme.shadows,
  breakpoints: theme.breakpoints,
} as const;
